<nav class="navbar navbar-static-top header d-flex" role="navigation">
  <div class="container-header d-flex align-items-center justify-content-between w-100 px-4" id="headerContainer">
    @if (config(); as config) {
      <div class="row flex-grow-1 gx-2 align-items-center">
        <div class="col d-flex header-logo justify-content-start flex-grow-1">
          @if (config?.backUrl) {
            <a (click)="navigateByUrl(config.backUrl)" class="back-to-overview mr-4">
              <i class="mynaui-arrow-left m-0"></i>
            </a>
          }
          <a class="logo">
            <span class="title">{{ (config.translated ? config.title : (config?.title | translate)) || title }}</span>
          </a>
        </div>
        <div class="col d-lg-flex justify-content-end menu flex-grow-0 flex-shrink-1 flex-md-shrink-0 right-menu">
          <app-user-menu />

          @if (showFeedbackWidget) {
            <div>
              <button id="feedbackWidget" class="feedback-widget" aria-hidden="true">
                <i class="mynaui-bell" [pTooltip]="feedbackTooltip" tooltipStyleClass="neqto-tooltip"></i>
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</nav>

<ng-template #feedbackTooltip>
  <div>
    {{ 'feedback.trigger.label' | translate }}
  </div>
</ng-template>
